import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import * as jwt_decode from 'jwt-decode';
import { singleSpaPropsSubject } from './../../../../single-spa/single-spa-props';
import { AppSyncService } from './appsync.service'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(public appSyncService:AppSyncService){}
  token: string = null;
  dealerIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  employeeIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  employeeNameSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  employeeRolesSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  dealerIdLoaded: boolean;

  getToken() {
    return this.token;
  }

  getDealerId() {
    return this.dealerIdSubject.asObservable();
  }

  getDealerIdValue() {
    return this.dealerIdSubject.value;
  }
  
  setDealerId(dealerId: string) {
    this.dealerIdLoaded = true;
    this.dealerIdSubject.next(dealerId);
  }

  getEmployeeId() {
    return this.employeeIdSubject.asObservable();
  }

  setEmployeeId(employeeId: string) {
    this.employeeIdSubject.next(employeeId);
  }

  getEmployeeName() {
    return this.employeeNameSubject.asObservable();
  }

  setEmployeeName(employeeName: string) {
    this.employeeNameSubject.next(employeeName);
  }

  getEmployeeRoles() {
    return this.employeeRolesSubject.asObservable();
  }

  setEmployeeRoles(employeeRoles: string[]) {
    if (employeeRoles && employeeRoles.length > 0) {
      this.employeeRolesSubject.next(employeeRoles);
    }
  }

  getSingleSpaProps() {
    return singleSpaPropsSubject.asObservable();
  }

  parseDealerInfo(token: string, dealerId: string, roles: string[]) {
    let userJwt: any;
    let isAuthenticated;
    try {
      userJwt = jwt_decode(token);
      isAuthenticated = !!userJwt;
    } catch (error) {
      isAuthenticated = false;
    }

    if (isAuthenticated && !this.dealerIdLoaded) {
      this.token = token;
      this.setDealerId(dealerId);
      this.setEmployeeId(userJwt.UserId);
      this.setEmployeeName(userJwt.preferred_name);
      this.appSyncService.mutationAddSubscribe(dealerId,userJwt.UserId || userJwt.sub || userJwt.subname);
      const roleList: string[] = userJwt.roles ? userJwt.roles.split(',') : roles;
      this.setEmployeeRoles(roleList);
    }
  }
}
